class CartUpsellVariantPicker extends HTMLElement {
    connectedCallback() {
      const variantData = this.querySelector('[data-variants]');
      if (!variantData) return;

      this.variants = JSON.parse(variantData.textContent);
      this.selects = [...this.querySelectorAll('select[data-option-index]')];
      this.moneyFormat = this.dataset.moneyFormat;
      this.labels = {
        regular: this.dataset.labelRegular,
        sale: this.dataset.labelSale,
      };

      this.selects.forEach((select) => {
        select.addEventListener('change', this.onVariantChange.bind(this));
      });
    }

    /** @returns {string[]} */
    getSelectedOptions() {
      return this.selects.map((s) => s.value);
    }

    /** @param {string[]} selectedOptions @returns {Object|undefined} */
    findVariant(selectedOptions) {
      return this.variants.find((v) => v.options.every((opt, i) => opt === selectedOptions[i]));
    }

    /** @returns {Element|null} */
    getProductCard() {
      return this.closest('.cart-upsell__product-card');
    }

    onVariantChange() {
      const variant = this.findVariant(this.getSelectedOptions());
      if (!variant) return;

      this.updatePrice(variant);

      this.getProductCard()?.dispatchEvent(
        new CustomEvent('cart-upsell:variant-changed', {
          bubbles: false,
          detail: { variant },
        })
      );
    }

    /** @param {Object} variant */
    updateVariantInput(variant) {
      const card = this.getProductCard();
      if (!card) return;

      const input = card.querySelector('input[name="id"]');
      if (input) input.value = variant.id;
    }

    /** @param {Object} variant */
    updatePrice(variant) {
      const card = this.getProductCard();
      if (!card) return;

      const priceContainer = card.querySelector('[ref="priceContainer"]');
      if (!priceContainer) return;

      const price = this.formatMoney(variant.price);
      const compareAt = variant.compare_at_price;
      const isOnSale = compareAt && compareAt > variant.price;

      let html = '';

      if (isOnSale) {
        html += `
        <span role="group">
          <span class="visually-hidden">${this.labels.regular}&nbsp;</span>
          <span class="compare-at-price">${this.formatMoney(compareAt)}</span>
        </span>
        <span role="group">
          <span class="visually-hidden">${this.labels.sale}&nbsp;</span>
          <span class="price">${price}</span>
        </span>
      `;
      } else {
        html += `<span class="price">${price}</span>`;
      }

      priceContainer.innerHTML = html;
    }

    /**
     * Formats cents to a money string using the shop's money format.
     * Falls back to Shopify.formatMoney if available, otherwise a basic formatter.
     * @param {number} cents
     * @returns {string}
     */
    formatMoney(cents) {
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, this.moneyFormat);
      }

      // Basic fallback: handles {{amount}} and {{amount_no_decimals}}
      const amount = (cents / 100).toFixed(2);
      return this.moneyFormat
        .replace('{{amount}}', amount)
        .replace('{{amount_no_decimals}}', Math.round(cents / 100).toString())
        .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
        .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100).toString());
    }
  }

  if (!customElements.get('cart-upsell-variant-picker')) {
    customElements.define('cart-upsell-variant-picker', CartUpsellVariantPicker);
  }